import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router'
import { useDocumentPDF } from '~/entities/document'
import { PDFDocument } from '~/shared/ui'

export function DocumentPdfViewPage() {
  const documentKey = useParams<'documentKey'>().documentKey as string
  const { data: pdfUrl, isFetching } = useDocumentPDF(documentKey)
  const [blobUrl, setBlobUrl] = useState<string | null>(null)
  const [isFetchingBlob, setIsFetchingBlob] = useState(false)
  const [fetchError, setFetchError] = useState(false)
  const blobUrlRef = useRef<string | null>(null)

  useEffect(() => {
    if (!pdfUrl || blobUrl || isFetchingBlob || fetchError) return

    const fetchBlob = async () => {
      setIsFetchingBlob(true)
      try {
        const response = await fetch(pdfUrl, { credentials: 'include' })
        if (response.status === 200) {
          const blob = await response.blob()
          const url = URL.createObjectURL(blob)
          blobUrlRef.current = url
          setBlobUrl(url)
        } else {
          setFetchError(true)
        }
      } catch {
        setFetchError(true)
      } finally {
        setIsFetchingBlob(false)
      }
    }

    fetchBlob()
  }, [pdfUrl, blobUrl, isFetchingBlob, fetchError])

  useEffect(() => {
    return () => {
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current)
      }
    }
  }, [])

  const fileUrl = blobUrl || pdfUrl || null
  const isLoading = isFetching || isFetchingBlob

  return (
    <div className="h-dvh">
      <PDFDocument
        file={fileUrl}
        isLoading={isLoading}
        showFullscreen={false}
        initialFitToWidth
      />
    </div>
  )
}
